import { ArticleApprovalRequest } from '@/common/model/media/article'

export const ArticleApprovalApiPath = {
  LIST_ARTICLE_APPROVALS: '/api/sites/{site_id}/article-approvals', // GET List Article Approvals
  GET_ARTICLE_APPROVAL: '/api/sites/{site_id}/article-approvals/{request_id}', // GET Get Article Approval
  UPDATE_ARTICLE_APPROVAL_SCHEDULE: '/api/sites/{site_id}/article-approvals/{request_id}', // PUT Update Article Approval Schedule
  APPROVE_ARTICLE_APPROVAL: '/api/sites/{site_id}/article-approvals/{request_id}/approve', // POST Approve
  REJECT_ARTICLE_APPROVAL: '/api/sites/{site_id}/article-approvals/{request_id}/reject', // POST Reject
  CANCEL_ARTICLE_APPROVAL: '/api/sites/{site_id}/article-approvals/{request_id}/cancel' // POST Cancel Article Approval
}

export type ArticleApprovalApiPath =
  (typeof ArticleApprovalApiPath)[keyof typeof ArticleApprovalApiPath]

export interface ListArticleApprovalsVars {
  site_id: number
  status?: string | null
  requested_by?: number | null
  approver_id?: number | null
}

export interface GetArticleApprovalVars {
  site_id: number
  request_id: number
}

export interface UpdateArticleApprovalScheduleVars {
  site_id: number
  request_id: number
  scheduled_upload_at: string
}

export interface ApproveArticleApprovalVars {
  site_id: number
  request_id: number
  comment?: string | null
}

export interface RejectArticleApprovalVars {
  site_id: number
  request_id: number
  comment?: string | null
}

export interface CancelArticleApprovalVars {
  site_id: number
  request_id: number
}

// 承認可能なオペレーター1人分の承認状況（単一承認方式。D11：実際に確定するのは1人だが、
// 承認権限を持つ全オペレーターの状況を一覧表示する）
export interface ApprovalVoteItem {
  operator_id: number
  name: string
  result: 'approved' | 'rejected' | null
  comment: string | null
  acted_at: string | null
}

export interface ArticleApprovalDetail extends ArticleApprovalRequest {
  article_proposal_id: number | null
  page_id: string
  title: string | null
  version_number: number
  meta_description: string | null
  approver_count: number
  requested_by_name: string | null
  approved_by_name: string | null
  rejected_by_name: string | null
  can_approve: boolean
  approvers: ApprovalVoteItem[]
}

// 一覧APIの軽量項目（詳細とは別形）
export interface ArticleApprovalListItem {
  id: number
  article_version_id: number
  page_id: string | null
  title: string | null
  version_number: number | null
  status: string
  scheduled_upload_at: string | null
  requested_by_name: string | null
  requested_at: string | null
  approved_by_name: string | null
  approved_at: string | null
  rejected_by_name: string | null
  rejected_at: string | null
  approver_count: number
}

export type ListArticleApprovalsResponse = ArticleApprovalListItem[]
export type GetArticleApprovalResponse = ArticleApprovalDetail

export interface UpdateArticleApprovalScheduleResponse {
  ok: boolean
  scheduled_upload_at: string
}

export interface ApprovalActionResponse {
  ok: boolean
  status: string
}

export interface CancelArticleApprovalResponse {
  ok: boolean
}
